// extracted by mini-css-extract-plugin
module.exports = {"illustrationWrapper":"_normal--illustrationWrapper--4xIz-"};